module.exports = __webpack_public_path__ + "img/Newbie_Dagger_02_Mage.b98d794c.png";